// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class MedicalV1PriorAuthorizationInterfacesPriorAuthorizationPrescription {
    'daysSupply'?: string;
    'drug'?: string;
    'ndc'?: string;
    'quantity'?: string;
    'refill'?: string;
    'sig'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof MedicalV1PriorAuthorizationInterfacesPriorAuthorizationPrescription>> = [
        {
            "name":     "daysSupply",
            "baseName": "daysSupply",
            "type":     "string"
        },
        {
            "name":     "drug",
            "baseName": "drug",
            "type":     "string"
        },
        {
            "name":     "ndc",
            "baseName": "ndc",
            "type":     "string"
        },
        {
            "name":     "quantity",
            "baseName": "quantity",
            "type":     "string"
        },
        {
            "name":     "refill",
            "baseName": "refill",
            "type":     "string"
        },
        {
            "name":     "sig",
            "baseName": "sig",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return MedicalV1PriorAuthorizationInterfacesPriorAuthorizationPrescription.attributeTypeMap;
    }
}
